import createParseMiddleware from './createParseMiddleware';
import { parseVisitorTypeResponse } from 'utils/apiParser/visitorTypeParser';
import { VisitorType } from 'types/VisitorTypeTypes';

export const parseFetchVisitorTypesMiddleware = createParseMiddleware<VisitorType>(parseVisitorTypeResponse, 'visitorTypes/fetchVisitorTypes');
